export default __webpack_public_path__ + "static/media/linkedin.058f585d.svg";